import { useState, useEffect } from "react";
import { PlansConfigV3 } from "../types";
import { subscribePlansConfigV3 } from "../services/stripeService";

export function usePlansConfigV3() {
  const [plansConfig, setPlansConfig] = useState<PlansConfigV3 | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = subscribePlansConfigV3((config) => {
      setPlansConfig(config);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return { plansConfig, loading };
}
